import React from "react";

function CabQueues() {
  return <div>CabQueues</div>;
}

export default CabQueues;
